import { auth } from '@link/agent/stores';
import ShareAuth from '@link/share/vendors/firebase';

const agentAuth = new ShareAuth(auth);

export const storage = agentAuth.storage;
export default agentAuth;
